import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, FuelIcon, GiftIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} tomos premium`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} bonos estratégicos`
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-stone-50" data-id="element-110" data-mp="sarsclmrys9u">
      <div className="h-2 w-full bg-amber-500" aria-hidden="true" data-id="element-111" data-mp="nc894szkful6" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-12 text-center lg:pb-20 lg:pt-16" data-id="element-112" data-mp="nbyhl0yvhfdd">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-md bg-emerald-900 px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-amber-300" data-id="element-113" data-mp="3d33gp3txj3ne">
          <FuelIcon className="h-4 w-4" aria-hidden="true" data-id="element-114" data-mp="3o59cvlo65afl" /> Megapack Petróleo y Gas Listo
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.05] text-emerald-950 sm:text-5xl lg:text-6xl" data-id="element-115" data-mp="3e9fuvmrokoqf">
          Todo tu año de Petróleo y Gas
          <br data-id="element-116" data-mp="2qhqtlgwvspxc" />
          <span className="text-stone-700 underline decoration-amber-500 decoration-[6px] underline-offset-[10px]" data-id="element-117" data-mp="2qi0lja1hl75o">
            resuelto en una tarde.
          </span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-10 max-w-3xl rounded-2xl border border-stone-200 bg-white p-3 shadow-xl shadow-stone-900/10 sm:p-5" data-id="element-118" data-mp="2hl9qn0yo7yco">
          <img src={productImage} alt="Megapack Petróleo y Gas Listo: nueve tomos y cinco bonos sobre fundamentos, geología, exploración, perforación, producción, refinación, transporte, seguridad y enseñanza del petróleo y gas" className="mx-auto w-full rounded-xl" data-id="element-119" data-mp="iboyiltrcouw" />
        </motion.div>

        <div className="mt-9" data-id="element-120" data-mp="162c9jfyyzulo">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-121" data-mp="15zzupboie0cu">
            Quiero mi Megapack ahora
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-emerald-900" data-id="element-122" data-mp="x031cwr6cdbg">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-md border border-stone-200 bg-white px-3 py-2" data-id="element-123" data-mp="3hrd9yx6dbe0y">
              <Icon className="h-3.5 w-3.5 text-amber-600" aria-hidden="true" data-id="element-124" data-mp="1xb5o89ocuje0" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}